import { useQueries } from '@tanstack/react-query';

import PriceParrotService from '~/services/PriceParrotService';

import type { CompetitorProperty } from '~/types/services/priceParrot';

import { competitorOffersQueryKeys } from './competitorOffersQueryKeys';

// Collection history for each of a hotel's competitor listings, in the same order.
export function useGetCompetitorPropertyHistories(properties: Array<CompetitorProperty>) {
  return useQueries({
    queries: properties.map((property) => ({
      queryKey: competitorOffersQueryKeys.history(property.sourceName, property.externalPropertyId),
      queryFn: async ({ signal }: { signal: AbortSignal }) =>
        (
          await PriceParrotService.getCompetitorPropertyHistory(
            property.sourceName,
            property.externalPropertyId,
            signal,
          )
        ).data,
    })),
  });
}
